/** Read an image file as raw base64 (no data-URL prefix). */
export function readFileAsBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result;
            if (typeof result !== "string") {
                reject(new Error("Failed to read file"));
                return;
            }
            const comma = result.indexOf(",");
            resolve(comma >= 0 ? result.substring(comma + 1) : result);
        };
        reader.onerror = () => reject(reader.error || new Error("Failed to read file"));
        reader.readAsDataURL(file);
    });
}

/** Fetch a URL and return raw base64 PNG/JPEG/WebP bytes. */
export async function fetchUrlAsBase64(imageUrl) {
    const response = await fetch(imageUrl);
    if (!response.ok) {
        throw new Error("Failed to load image");
    }
    const blob = await response.blob();
    return readFileAsBase64(blob);
}
